<template>
  <div class="stripe lockdown" :class="status">
    <div class="overlay center" v-if="modal">
      <div class="modal center">
        <img src="@/assets/img/modal-lockdown.svg" alt="Lockdown" />
        <p>Start Lockdown?</p>
        <span>Lockodwn will stop all production.</span>
        <div class="buttons">
          <div class="button ghost" @click="modal = false">Cancel</div>
          <div class="button" @click="startLockdown">Start!</div>
        </div>
      </div>
    </div>

    <!-- Inactive -->
    <div class="inactive" v-if="!available && !lockdown">
      <img src="@/assets/img/lockdown.svg" alt="Lockdown" />
      <span>Lockdown avialable in {{ lockTime }} days</span>
    </div>

    <!-- Inactive -->
    <div class="ready" v-if="available && !enabled && !lockdown">
      <div class="center">
        <img src="@/assets/img/lockdown.svg" alt="Lockdown" />
        <span>Lockdown is avialable</span>
      </div>
      <div class="button ghost" @click="modal = true">Start</div>
    </div>

    <div class="active" v-if="$store.state.lockdown">
      <img src="@/assets/img/lockdown.svg" alt="Lockdown" />
      <span>Lockdown ends in {{ $store.state.lockTime }} days</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LockDown",
  components: {},
  props: {},
  computed: {
    time: function() {
      return this.$store.state.time;
    },

    lockTime: function() {
      return this.$store.state.lockTime;
    },

    lockdown: function() {
      return this.$store.state.lockdown;
    },
  },

  data() {
    return {
      enabled: false,
      available: false,
      modal: false,
      status: "inactive", // inactive, available, active
    };
  },

  watch: {
    // Tick
    time: function() {
      if (!this.lockdown) {
        // disabled
        if (this.lockTime < 31 && this.lockTime > 1) {
          this.$store.commit("setLockdownTime", this.lockTime - 1);
        } else {
          // enabling
          this.status = "available";
          this.available = true;
        }
      } else {
        // active
        if (this.lockTime < 15 && this.lockTime > 1) {
          this.status = "active";
          this.$store.commit("setLockdownTime", this.lockTime - 1);
          // setting back inactive
        } else {
          this.status = "inactive";
          this.$store.commit("setLockdown", false);
          this.$store.commit("setLockdownTime", 14);
          this.available = false;
          this.enabled = false;
        }
      }
    },
  },

  mounted: function() {
    if (this.lockdown) {
      this.status = "active";
    }
  },

  methods: {
    startLockdown: function() {
      this.modal = false;
      this.status = "active";
      this.$store.commit("setLockdownTime", 7);
      this.enabled = true;
      this.$store.commit("setLockdown", true);
      this.track("lockdown", "lockdown");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.stripe {
  width: 100%;
  background: rgba(140, 140, 160, 0.9);
  color: #fff;
  padding: 4px 16px;
  transition: 0.2s;

  > div {
    display: flex;
    align-items: center;
  }

  .ready {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    div {
      flex-direction: row;
    }
  }

  img {
    margin-right: 8px;
  }
  .inactive {
  }
}

.available,
.active {
  background: $orange;
  span {
    font-weight: 600;
  }
}
</style>
